import React from "react";

import "./styles.scss"
import ManageFiles from "../../esg-chat/manage-files";

const CustomSourceList = () => {
    return (
        <ManageFiles />
    )
}

export default CustomSourceList